'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { ButtonV2 } from 'components/shared/ButtonV2';
import CustomLink from 'components/shared/CustomLink';
import { CaretUp } from 'assets/icons';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import styles from './ClosingSection.module.css';
// import { useModal } from 'components/shared/Modal';
// import { TypeformSnippet } from 'components/shared/TypeformSnippet';

const CLOSING_IMAGE_PATH = 'web_v2/ring-pro/landing-page/closing-ring-pro.png';

const scrollToVideo = () => {
  document
    .getElementById('video-section')
    ?.scrollIntoView({ behavior: 'smooth' });
};

const ClosingSection = () => {
  const t = useTranslations('ring-pro');
  const { region } = useRegionLocale();
  const isUS = region === 'US';
  // const ModalClient = useModal();

  // const openNotifyModal = () => {
  //   const url =
  //     typeof window !== 'undefined'
  //       ? window.location.hostname + window.location.pathname
  //       : 'website';
  //   ModalClient.set(
  //     <div
  //       style={{
  //         height: 'min(600px, 60vh)',
  //         width: 'calc(100vw - 48px)',
  //         maxWidth: 780,
  //       }}
  //     >
  //       <TypeformSnippet
  //         typeformId="nSUlX33B"
  //         frameTitle="Notify me"
  //         style={{ width: '100%', height: '100%' }}
  //         trackingParams={{
  //           utm_source: url,
  //           utm_medium: 'ring-pro-closing',
  //         }}
  //       />
  //     </div>,
  //   );
  //   ModalClient.setCloseButtonTheme('light');
  //   ModalClient.show();
  // };

  return (
    <section className={styles.section}>
      <div className={styles.contentContainer}>
        <h2 className={styles.heading}>{t('ring-pro.closing.heading')}</h2>
        <div className={styles.ctaWrapper}>
          {isUS ? (
            <>
              <ButtonV2
                variant="blue"
                aria-label={t('ring-pro.common.buyAriaLabel')}
                // onClick={openNotifyModal}
                href={'/ring-pro/buy'}
              >
                {t('ring-pro.common.buyNow')}
              </ButtonV2>
              <ButtonV2
                variant="transparentDark"
                aria-label={t('ring-pro.common.watchVideo')}
                onClick={scrollToVideo}
              >
                {t('ring-pro.common.watchVideo')}
              </ButtonV2>
            </>
          ) : (
            <ButtonV2
              href="/ring-pro/buy"
              variant="blue"
              aria-label={t('ring-pro.common.buyAriaLabel')}
            >
              {t('ring-pro.common.buyNow')}
            </ButtonV2>
          )}
        </div>
        <CustomLink href="/ring-pro/faq" className={styles.faqLink}>
          {t('ring-pro.closing.seeAllFaqs')}
          <CaretUp
            aria-hidden
            fill="currentColor"
            style={{ transform: 'rotate(90deg)' }}
            width={12}
            height={12}
          />
        </CustomLink>
      </div>
      <div className={styles.imageWrapper}>
        <CustomImage
          className={styles.productImage}
          src={CLOSING_IMAGE_PATH}
          alt={t('ring-pro.closing.imageAlt')}
          width={1512}
          height={1512}
          quality={90}
        />
      </div>
    </section>
  );
};

export default ClosingSection;
